enum AttachmentPreviewMode {
    None,
    Edit,
    Selected,
    SelectedAndPending,
    SelectedAndSaving,
    NotSelectedAndSaving,
    OtherSaving,
    PendingNavigation,
}

export default AttachmentPreviewMode;
